import { RootState } from '../../store';

export const getIdToDeleteSelector = (state: RootState) => state?.roleReducer?.roleIdToDelete;
